var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaqIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    width: 30,
    height: 30,
    viewBox: "0 0 29.967 29.967",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{stroke-width:0.15px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.075 0.075)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8 -8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.874,8A8.871,8.871,0,0,0,8,16.874V28.943a8.871,8.871,0,0,0,8.874,8.874H28.943a8.87,8.87,0,0,0,8.874-8.874V16.874A8.871,8.871,0,0,0,28.943,8Zm0,1.42H28.943A7.422,7.422,0,0,1,36.4,16.874V28.943A7.422,7.422,0,0,1,28.943,36.4H16.874A7.422,7.422,0,0,1,9.42,28.943V16.874A7.422,7.422,0,0,1,16.874,9.42Zm6.045,4.26a5.731,5.731,0,0,0-5.657,3.785.652.652,0,0,0,.472.822.721.721,0,0,0,.886-.438c.007-.021.013-.043.017-.064A4.442,4.442,0,0,1,22.92,15a5.091,5.091,0,0,1,2.973.957,2.9,2.9,0,0,1,1.276,2.335,3.028,3.028,0,0,1-.632,2.14,7.1,7.1,0,0,1-1.542,1.193,5.72,5.72,0,0,0-1.919,1.9A7.781,7.781,0,0,0,22.21,27.5a.714.714,0,0,0,1.42,0,6.565,6.565,0,0,1,.688-3.353,4.292,4.292,0,0,1,1.5-1.461,7.769,7.769,0,0,0,1.852-1.45,4.415,4.415,0,0,0,.921-2.952,4.241,4.241,0,0,0-1.819-3.353A6.459,6.459,0,0,0,22.92,13.679Zm0,16.329a1.065,1.065,0,1,0,1.065,1.065,1.065,1.065,0,0,0-1.065-1.065Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIcon);
export default __webpack_public_path__ + "static/media/faq_icon.9c83df1c1e52a10a773f992ee10aa4cc.svg";
export { ForwardRef as ReactComponent };